// Phase-102 · /dashboard/_debug/role
// Renders the logged-in user's {role, scope, manager_id} as proof
// that the new auth payload + RoleGate plumbing works end-to-end.
import useAuthStore from "../store/authStore";
import RoleGate from "../components/RoleGate";

function Inner() {
  const user = useAuthStore((s) => s.user);
  return (
    <div className="p-8 max-w-2xl mx-auto" data-testid="debug-role-page">
      <h1 className="text-2xl font-bold mb-1 font-['Outfit']">Role / Scope Debug</h1>
      <p className="text-sm text-slate-500 mb-6">
        Phase-102 plumbing check. Hidden from production once Phase-104 ships.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card label="User"        value={user?.name || "—"} />
        <Card label="Email"       value={user?.email || "—"} />
        <Card label="Role"        value={user?.role || "—"} mono />
        <Card label="is_b2b"      value={String(user?.is_b2b ?? false)} mono />
        <Card label="is_active"   value={String(user?.is_active ?? "—")} mono />
        <Card label="manager_id"  value={user?.manager_id || "—"} mono />
      </div>
      <div className="mt-4 bg-slate-900 text-slate-100 rounded-xl p-4 font-mono text-xs"
           data-testid="debug-role-scope">
        <div className="text-slate-400 mb-1">scope:</div>
        <pre className="whitespace-pre-wrap">{JSON.stringify(user?.scope || {}, null, 2)}</pre>
      </div>
    </div>
  );
}

function Card({ label, value, mono }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4">
      <div className="text-xs text-slate-500 mb-1">{label}</div>
      <div className={`text-sm ${mono ? "font-mono" : ""} text-slate-800 break-all`}>
        {value}
      </div>
    </div>
  );
}

export default function DebugRole() {
  // Any logged-in user can hit this debug page — that's the point of the
  // demo. We still wrap with a RoleGate to prove the HOC works (denyBelowTier=6
  // = everyone, including customers).
  return (
    <RoleGate denyBelowTier={6}>
      <Inner />
    </RoleGate>
  );
}
